import api from '../../models/orderplan'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  name: 'orderrelease',
  data() {
    return {
      search_text: '',
      search_date: null,
      active_page: 1,
      per_page: 100,
      is_load: false,
      dk_id: 0,
      dock_list: [],
      round: '',
      round_list: [],
      spl_id: 0,
      supplier_list: [],
      cycle_time: '',
      cycle_list: [],
      export_data: '',
      result_data: {
        pagination: [],
        count: 0
      }
    }
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      this.search_date = moment()
      this.getDockList()
      this.getCycleList()
      // this.getReleaseRound()
      this.getSupplierList()
      this.activePage(this.active_page)
      $('#select2-supplier').select2({
        placeholder: 'Supplier Code',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-supplier').on('select2:select', (e) => {
        this.changeSupplier($('#select2-supplier').val())
      })
      $('#select2-supplier').on('select2:clear', (e) => {
        this.changeSupplier('')
      })
      $('#select2-dock').select2({
        placeholder: 'Select Dock',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-dock').on('select2:select', (e) => {
        this.changeDock($('#select2-dock').val())
      })
      $('#select2-dock').on('select2:clear', (e) => {
        this.changeDock('')
      })
      $('#select2-cycle').select2({
        placeholder: 'Select Cycle',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-cycle').on('select2:select', (e) => {
        this.changeCycle($('#select2-cycle').val())
      })
      $('#select2-cycle').on('select2:clear', (e) => {
        this.changeCycle('')
      })
      $('#select2-round').select2({
        placeholder: 'Select Round',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-round').on('select2:select', (e) => {
        this.changeRound($('#select2-round').val())
      })
      $('#select2-round').on('select2:clear', (e) => {
        this.changeRound('')
      })
    }, 1000)
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.getOrderRelease()
    },
    changeSupplier(id) {
      this.spl_id = id === '' ? 0 : id
      this.activePage(this.active_page)
    },
    changeDock(id) {
      this.dk_id = id === '' ? 0 : id
      this.activePage(this.active_page)
    },
    changeCycle(id) {
      this.cycle_time = id === '' ? '' : id
      this.activePage(this.active_page)
    },
    changeRound(id) {
      this.round = id === '' ? 0 : id
      this.activePage(this.active_page)
    },
    getOrderRelease() {
      this.is_load = true
      var obj = {
        page: this.active_page,
        limit: this.per_page,
        date:
          this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dock: this.dk_id,
        round: this.round,
        supplier: this.spl_id,
        cycle: this.cycle_time,
        search: this.search_text
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.getOrderRelease(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data.pagination = result.data.pagination
            this.result_data.count = result.data.count
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
          this.is_load = false
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.is_load = false
        }
      )
    },
    exportData() {
      this.export_list = []
      var obj = {
        date:
          this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dock: this.dk_id,
        supplier: this.spl_id,
        cycle: this.cycle_time,
        search: this.search_text
      }
      this.header.params = obj
      api.getExportList(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.export_data = JSON.stringify(result.data.export_list)
            setTimeout(() => {
              this.$refs.ExportText.submit()
            }, 1000)
          } else {
            this.alert_msg('warning', 'Order Release Export', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Order Release Export', error.message)
        }
      )
    },
    releaseProcess() {
      swal
        .fire({
          title: 'Order Release',
          text: 'You want to Process Order Release ?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel'
        })
        .then((result) => {
          if (result.value) {
            if (this.search_date !== '' && this.cycle_time !== '') {
              var obj = {
                date:
                  this.search_date !== null
                    ? this.dateFormatYMD(this.search_date)
                    : '',
                cycle: this.cycle_time
              }
              this.header.params = {}
              api.releaseProcess(
                this.$store.state.URLHost,
                obj,
                this.header,
                (result) => {
                  if (result.response === true) {
                    // this.getReleaseRound()
                    this.alert_msg(
                      'success',
                      'Process Order Release',
                      result.message
                    )
                  } else {
                    this.alert_msg(
                      'warning',
                      'Process Order Release.',
                      result.message
                    )
                  }
                },
                (error) => {
                  this.alert_msg('error', 'An error occurred.', error.message)
                }
              )
            } else {
              this.alert_msg(
                'warning',
                'Process Order Release.',
                'Require input Date & Cycle'
              )
            }
          }
        })
    },
    getReleaseRound() {
      this.round_list = []
      var obj = {
        date:
          this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        cycle: this.cycle_time
      }
      this.round = ''
      this.header.params = obj
      api.getReleaseRound(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.round_list = result.data.round_list
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    rmOrder (ord_id) {
      swal.fire({
        title: 'Remove Order',
        text: 'You want to remove this order ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          $('.preloader').fadeIn()
          api.rmOrder(
            this.$store.state.URLHost,
            ord_id,
            this.header,
            (result) => {
              if (result.response === true) {
                this.activePage(this.active_page)
                this.alert_msg('success', 'Remove Order', result.message)
                $('.preloader').fadeOut()
              } else {
                $('.preloader').fadeOut()
                this.activePage(this.active_page)
                this.alert_msg('warning', 'Remove Order', result.message)
              }
            },
            (error) => {
              $('.preloader').fadeOut()
              this.alert_msg('error', 'Remove Order', error.message)
            }
          )
        }
      })
    },
    getDockList() {
      this.dock_list = []
      api.getDockList(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.dock_list = result.data.dock_list
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    getCycleList() {
      this.cycle_list = []
      var obj = {
        date:
          this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dk_id: this.dk_id
      }
      this.header.params = obj
      api.getCycleList(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.cycle_list = result.data.cycle_list
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    getSupplierList() {
      this.supplier_list = []
      api.getSupplierList(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.supplier_list = result.data.supplier_list
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    goOrderPlanUpload() {
      this.$router.push({
        name: 'OrderPlanUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/orderplan.js